import { EMPTY_VALUE } from '@/constants/app.constants';
import type { AssignedInstituteItem } from '../types/userInstituteMapping.types';

export interface DistrictGroup {
  districtName: string;
  institutes: AssignedInstituteItem[];
}

export function groupByDistrict(data: AssignedInstituteItem[]): DistrictGroup[] {
  const map = new Map<string, AssignedInstituteItem[]>();
  for (const item of data) {
    const key = item.district?.name ?? EMPTY_VALUE;
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(item);
  }
  return Array.from(map.entries()).map(([districtName, institutes]) => ({
    districtName,
    institutes,
  }));
}
